import { Box, Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledCheckbox, ControlledTextField } from 'components/common'
import { ControlledSelector, ISelectorOption } from 'components/common/controller-wrapper'
import { Roles } from 'constants/index'

const RoleValues: ISelectorOption[] = [
  { value: Roles.driverSubcontractor, label: Roles.driverSubcontractor },
  { value: Roles.transportController, label: Roles.transportController },
]

interface IProps {
  disableRoleSelection?: boolean
}

const SubDriverForm = (props: IProps) => {
  const { disableRoleSelection } = props
  const spacing = 3

  const {
    control,
    formState: { errors },
  } = useFormContext()

  return (
    <Box sx={{ marginTop: 1 }}>
      <Grid container spacing={spacing}>
        <Grid item xs={12} sm={6}>
          <ControlledTextField
            control={control}
            label='First Name'
            required
            name='firstName'
            error={!!errors.firstName}
            helperText={errors.firstName?.message}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledTextField
            control={control}
            label='Last Name'
            required
            name='lastName'
            error={!!errors.lastName?.message}
            helperText={errors.lastName?.message}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <ControlledTextField
            control={control}
            name='email'
            label='Email'
            type='email'
            required
            error={!!errors.email}
            helperText={errors.email?.message}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledTextField
            control={control}
            label='Telephone Number'
            name='telephoneNumber'
            required
            error={!!errors.telephoneNumber}
            helperText={errors.telephoneNumber?.message}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledCheckbox control={control} label='Active' name='isActive' />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledSelector
            options={RoleValues}
            name='role'
            label='Role'
            control={control}
            disabled={disableRoleSelection}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default SubDriverForm
